import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetAttendanceSessionCSVJobStatusResponse {
  success: boolean;
  job: Job;
}

export interface Job {
  jobId: string;
  sessionId: string;
  locationId: string;
  studioId: string;
  status: 'queued' | 'processing' | 'completed' | 'failed';
  totalClasses: number;
  processedClasses: number;
  failedClasses: number;
  downloadUrl: null | string;
  createdAt: string;
  updatedAt: string;
  error?: string;
}

export interface GetAttendanceSessionCSVJobStatusParams {
  jobId: string;
}

export const getAttendanceSessionCSVJobStatusAPI = async (
  params: GetAttendanceSessionCSVJobStatusParams,
) => {
  const response = await baseAPI.get<GetAttendanceSessionCSVJobStatusResponse>(
    `/attendance/session-csv-status/${params.jobId}`,
  );
  return response.data;
};

export const getAttendanceSessionCSVJobStatusQueryOptions = (
  params: GetAttendanceSessionCSVJobStatusParams,
) =>
  queryOptions({
    queryKey: [KEYS.ATTENDANCE_SESSION_CSV_JOB_STATUS, params.jobId],
    queryFn: () => getAttendanceSessionCSVJobStatusAPI(params),
    enabled: !!params.jobId,
  });

export const useGetAttendanceSessionCSVJobStatus = (
  params: GetAttendanceSessionCSVJobStatusParams,
) => {
  return useQuery(getAttendanceSessionCSVJobStatusQueryOptions(params));
};
